import { render } from "./ComicDetail.vue?vue&type=template&id=f89ccd4e&scoped=true"
import script from "./ComicDetail.vue?vue&type=script&lang=js"
export * from "./ComicDetail.vue?vue&type=script&lang=js"

import "./ComicDetail.vue?vue&type=style&index=0&id=f89ccd4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89ccd4e"]])

export default __exports__